import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart, ActivationEnd } from '@angular/router';

import { Principal } from '../../services/auth/principal.service';
import { CoreConfigService } from '../../services/config/core-config.service';
import { AppSettingService } from '../../services/service/app-setting.service';
import { UserContextService } from '../../services/service/user-context.service';
import { ReadyStateFlag } from '../../services/service/ready-state.model';
import { ResetPasswordService } from '../../services/auth/reset-password.service';

@Component({
	selector: 'zx-app-entry',
	templateUrl: './app-entry.component.html',
	styleUrls: ['./app-entry.component.css']
})
export class AppEntryComponent implements OnInit {
	isReady:boolean = false;
	readyError: string = null;
	loadingMessage:string = null;

	private hiddenScrolling:boolean = false;
	private _checkStateTimer = null;
	private _stateSubscription = null;


	constructor(
        private elementRef: ElementRef,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private principal: Principal,
		private appSettings: AppSettingService,
		private configService: CoreConfigService,
		private userContext: UserContextService,
		private resetPasswordService: ResetPasswordService
	) { 
	}

	ngOnInit() {
		this.isReady = (this.appSettings.getCommonSettings()!=null);
		if(!this.isReady){
			if(this._stateSubscription != null) return;
			this._stateSubscription = this.appSettings.commonSettingReadyStateChange.subscribe(readyState => {
				if(this.isReady) return;
				// console.log("AppEntryComponent.ngOnInit() -> readyState=", readyState);
				this.isReady = (readyState.state==ReadyStateFlag.READY);
				if(readyState.state == ReadyStateFlag.ERROR) this.readyError = readyState.message;
				else if(readyState.state == ReadyStateFlag.LOADING) this.loadingMessage = readyState.message;
				this._stateSubscription.unsubscribe();
			});
		}
		this.routerSubscribe();
	}

	routerSubscribe(){
		this.router.events.subscribe(event => {
			if (event instanceof ActivationEnd) {
				const hiddenScrolling = !!event.snapshot.data['hiddenScrolling']
				this.elementRef.nativeElement.style.overflow = hiddenScrolling?"hidden":"unset";
			}else if (event instanceof NavigationStart) {
				if (event.url == "/home"||event.url == "/"||event.url.endsWith("/404")) {
					this.goHomeOrLogin();
				}
			}
		});
	}
	

	goHomeOrLogin() {
		if(this._checkStateTimer != null) 
			clearTimeout(this._checkStateTimer);

		this._checkStateTimer = setTimeout(() => {
			this._checkStateTimer = null;
			// console.log("Login Checking ...");
			this.principal.identity().then(user => {
				if (user) this.goHome();
				else {
					this.router.navigate(['/login']);
				}
			}).catch(event => {
				this.router.navigate(['/login']);
			});
		}, 300);
	}
	goHome(){
		const homePage = this.configService.homePage;
		// console.log("AppEntryComponent.goHome -> homePage=", homePage);
		if(homePage&&!this.userContext.isPage404(homePage)) this.router.navigate([homePage]);
		else this.router.navigate(['/apps']);
	}
}
